import { render, staticRenderFns } from "./OfficialRecommend.vue?vue&type=template&id=2fbffacf&scoped=true"
import script from "./OfficialRecommend.vue?vue&type=script&lang=js"
export * from "./OfficialRecommend.vue?vue&type=script&lang=js"
import style0 from "./OfficialRecommend.vue?vue&type=style&index=0&id=2fbffacf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbffacf",
  null
  
)

export default component.exports